import { AppUtils } from '../../utils/index';
export class MembershipAddPersonsModel {
	private partner: boolean;
	private juv: boolean;
	private child: boolean;

	public get Partner(): boolean {
		return this.partner;
	}
	public set Partner(v: boolean) {
		this.partner = v;
	}

	public get Juv(): boolean {
		return this.juv;
	}
	public set Juv(v: boolean) {
		this.juv = v;
	}

	public get Child(): boolean {
		return this.child;
	}
	public set Child(v: boolean) {
		this.child = v;
	}

	public toString(): string {
		try {
			return JSON.stringify(this);
		} catch (e) {
			return Object.toString.apply(this);
		}
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	static createFromObject(dataObject: { [key: string]: any }): MembershipAddPersonsModel {
		return AppUtils.Helper.createFromMap(dataObject, MembershipAddPersonsModel);
	}
}